// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".assessDept {\n  display: inline-block;\n  min-width: 200px;\n}\n.assessDept label {\n  padding: 0 !important;\n}\n.assessDept label .q-field__inner {\n  padding: 0 !important;\n  padding-left: 10px !important;\n}", ""]);
// Exports
module.exports = exports;
